import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

const state = {
  currentUser: {
    isLoggedIn: false,
    id: "",
    prefix: "",
    firstName: "",
    lastName: "",
    email: "",
  },
  currentUserShippingAddress: {},
  currentUserBillingAddress: {},
};

export default {
  state,
  mutations,
  getters,
  actions,
};
